import React from 'react';

interface TooltipProps {
  children: React.ReactNode;
  label: string;
  position?: 'top' | 'right' | 'bottom' | 'left';
}

export default function Tooltip({ children, label, position = 'right' }: TooltipProps) {
  const positionClasses = {
    top: 'bottom-full left-1/2 -translate-x-1/2 mb-2',
    right: 'left-full top-1/2 -translate-y-1/2 ml-2',
    bottom: 'top-full left-1/2 -translate-x-1/2 mt-2',
    left: 'right-full top-1/2 -translate-y-1/2 mr-2'
  };

  return (
    <div className="group relative inline-block">
      {children}
      <div className={`absolute hidden group-hover:block z-50 ${positionClasses[position]}`}>
        <div className="bg-gray-900 text-white text-sm px-2 py-1 rounded whitespace-nowrap">
          {label}
        </div>
      </div>
    </div>
  );
}